import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ProductMasterDetailPageRBAC = {
  pageID: '4c1a89a06385a1b21b95c004090fa434',
  elementID: {
    viewPageDetail: 'f6052b6f15b218f87e68da87bb3a4a55',
    EditProduct: 'a612e6e3fa6cefcad7837cc5a459e915',
  },
}

export const useRBACProductMasterDetailPage = createUseRBAC(ProductMasterDetailPageRBAC.elementID)

export type UseRBACProductMasterDetailPageType = ReturnType<typeof useRBACProductMasterDetailPage>
